import { usersApi, usersPath } from '../paths'

/** Where Bulk Edit starts one, for the users Find Users' search, in its query, finds. */
export const bulkEditUsersPath = `${usersPath}/bulk-edits/new`

/** A bulk edit's report page. */
export const userBulkEditRoute = `${usersPath}/bulk-edits/:publicId`

/** A bulk edit's report. */
export function userBulkEditPath(id: string): string {
  return `${usersPath}/bulk-edits/${encodeURIComponent(id)}`
}

/** The API's bulk edits: POST starts one. */
export const userBulkEditsApi = `${usersApi}/bulk-edits`

/** A bulk edit. */
export function userBulkEditApi(id: string): string {
  return `${userBulkEditsApi}/${encodeURIComponent(id)}`
}

/** A bulk edit's users, the report. */
export function userBulkEditUsersApi(id: string): string {
  return `${userBulkEditApi(id)}/users`
}

/** Changing many chosen people at once, and seeing what a bulk edit did. */
export const bulkEditPermission = 'site-management.user-profiles.bulk-edit.write'

/** The most users one bulk edit takes, as the API checks. */
export const maxBulkEditUsers = 10_000
